import { useId } from 'react';
import { cn } from '@/lib/utils';

export const DailyCamIcon = ({
	muted = false,
	className,
}: {
	muted?: boolean;
	className?: string;
}) => {
	const maskId = useId();

	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
			className={cn('size-6 fill-current text-white', className)}
			aria-hidden
		>
			{muted ? (
				<>
					<mask id={maskId}>
						<rect x="0" y="0" width="24" height="24" fill="white" />
						<path
							d="M2.87715 19L18.8772 3"
							stroke="black"
							strokeWidth="1.5"
							strokeLinecap="round"
						/>
					</mask>
					<g mask={`url(#${maskId})`}>
						<path d="M5 7.5C3.89543 7.5 3 8.39543 3 9.5V14.5C3 15.6046 3.89543 16.5 5 16.5H13C14.1046 16.5 15 15.6046 15 14.5V9.5C15 8.39543 14.1046 7.5 13 7.5H5Z" />
						<path d="M16.5 10.9491C16.5 10.6634 16.6221 10.3914 16.8356 10.2017L19.3356 7.97943C19.9805 7.40618 21 7.86399 21 8.72684V15.2732C21 16.136 19.9805 16.5938 19.3356 16.0206L16.8356 13.7983C16.6221 13.6086 16.5 13.3366 16.5 13.0509V10.9491Z" />
					</g>
					<path
						d="M4 20L20 4"
						stroke="currentColor"
						strokeLinecap="round"
						strokeWidth="1.5"
					/>
				</>
			) : (
				<>
					<path d="M5 7.5C3.89543 7.5 3 8.39543 3 9.5V14.5C3 15.6046 3.89543 16.5 5 16.5H13C14.1046 16.5 15 15.6046 15 14.5V9.5C15 8.39543 14.1046 7.5 13 7.5H5Z" />
					<path d="M16.5 10.9491C16.5 10.6634 16.6221 10.3914 16.8356 10.2017L19.3356 7.97943C19.9805 7.40618 21 7.86399 21 8.72684V15.2732C21 16.136 19.9805 16.5938 19.3356 16.0206L16.8356 13.7983C16.6221 13.6086 16.5 13.3366 16.5 13.0509V10.9491Z" />
				</>
			)}
		</svg>
	);
};

export const DailyMicIcon = ({
	muted = false,
	className,
}: {
	muted?: boolean;
	className?: string;
}) => {
	const maskId = useId();

	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
			className={cn('size-6 fill-current text-white', className)}
			aria-hidden
		>
			{muted ? (
				<>
					<mask id={maskId}>
						<rect x="0" y="0" width="24" height="24" fill="white" />
						<path
							d="M2.88 19L18.88 3"
							stroke="black"
							strokeWidth="1.5"
							strokeLinecap="round"
						/>
					</mask>
					<g mask={`url(#${maskId})`}>
						<path d="M12 3C10.3431 3 9 4.34315 9 6V12C9 13.6569 10.3431 15 12 15C13.6569 15 15 13.6569 15 12V6C15 4.34315 13.6569 3 12 3Z" />
						<path d="M7.5 12C7.5 11.5858 7.16421 11.25 6.75 11.25C6.33579 11.25 6 11.5858 6 12C6 13.9175 6.62158 15.4436 7.73826 16.4858C8.67527 17.3603 9.90114 17.8386 11.25 17.9654V20.25C11.25 20.6642 11.5858 21 12 21C12.4142 21 12.75 20.6642 12.75 20.25V17.9654C14.0989 17.8386 15.3247 17.3603 16.2617 16.4858C17.3784 15.4436 18 13.9175 18 12C18 11.5858 17.6642 11.25 17.25 11.25C16.8358 11.25 16.5 11.5858 16.5 12C16.5 13.5825 15.9966 14.6814 15.2383 15.3892C14.4713 16.105 13.3583 16.5 12 16.5C10.6417 16.5 9.52867 16.105 8.76174 15.3892C8.00342 14.6814 7.5 13.5825 7.5 12Z" />
					</g>
					<path
						d="M4 20L20 4"
						stroke="currentColor"
						strokeLinecap="round"
						strokeWidth="1.5"
					/>
				</>
			) : (
				<>
					<path d="M12 3C10.3431 3 9 4.34315 9 6V12C9 13.6569 10.3431 15 12 15C13.6569 15 15 13.6569 15 12V6C15 4.34315 13.6569 3 12 3Z" />
					<path d="M7.5 12C7.5 11.5858 7.16421 11.25 6.75 11.25C6.33579 11.25 6 11.5858 6 12C6 13.9175 6.62158 15.4436 7.73826 16.4858C8.67527 17.3603 9.90114 17.8386 11.25 17.9654V20.25C11.25 20.6642 11.5858 21 12 21C12.4142 21 12.75 20.6642 12.75 20.25V17.9654C14.0989 17.8386 15.3247 17.3603 16.2617 16.4858C17.3784 15.4436 18 13.9175 18 12C18 11.5858 17.6642 11.25 17.25 11.25C16.8358 11.25 16.5 11.5858 16.5 12C16.5 13.5825 15.9966 14.6814 15.2383 15.3892C14.4713 16.105 13.3583 16.5 12 16.5C10.6417 16.5 9.52867 16.105 8.76174 15.3892C8.00342 14.6814 7.5 13.5825 7.5 12Z" />
				</>
			)}
		</svg>
	);
};
